var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._b(
      { staticClass: "booking-app", class: { "is-embedded": _vm.embedMode } },
      "div",
      _vm.embedMode ? { "data-iframe-height": "" } : {},
      false
    ),
    [
      !_vm.embedMode
        ? _c("header", { staticClass: "booking-header" }, [
            _c("div", { staticClass: "header-content" }, [
              _c("div", { staticClass: "logo" }, [
                _vm._v(_vm._s(_vm.$t("appName")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "header-actions" }, [
                _c("label", { staticClass: "lang-label" }, [
                  _vm._v(_vm._s(_vm.$t("language")))
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.$i18n.locale,
                        expression: "$i18n.locale"
                      }
                    ],
                    staticClass: "lang-select",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.$i18n,
                          "locale",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "en" } }, [_vm._v("EN")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "zh" } }, [_vm._v("中文")])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "header-badge" }, [
                  _vm._v(_vm._s(_vm.$t("selfBooking")))
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("main", { staticClass: "booking-main" }, [_c("router-view")], 1)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d53ab87e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d53ab87e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/BookingApp.vue
// module id = 376
// module chunks = 0